import React, { useEffect, useState } from 'react';

import paths from '../../constants/routes.json';
import { People_ContactData_contacts as Contact } from '../../types/graph/People_ContactData';
import PeopleItem from './PeopleItem';
import { Select, Toggle } from '../../components/common';
import { SelectItem } from '../../components/common/Select';
import { Link } from 'react-router-dom';
import EmptyGrid from './EmptyGrid';

interface IProps {
  contacts: (Contact | null)[];
}

//const items = [
//  { id: '0', label: 'All Teams', state: true },
//  { id: '1', label: 'Frontend Team', state: true },
//  { id: '2', label: 'Backend Team', state: false },
//  { id: '3', label: 'DevOps Team', state: true },
//];

const PeopleList: React.FC<IProps> = ({ contacts }) => {
  //const onTeamSelect = (item: SelectItem) => {};

  if (contacts.length <= 0) {
    return <EmptyGrid />;
  }

  return (
    <div className="w-full">
      {/* <div className="w-full md:w-1/3">
        <Select items={items} label="Project" onSelect={onTeamSelect} />
      </div> */}
      <div className="mt-4 bg-white shadow overflow-hidden sm:rounded-md">
        <ul className="divide-y divide-gray-200">
          {contacts.map((contact, index) => (
            <PeopleItem key={index} contact={contact} />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PeopleList;
